import { render, staticRenderFns } from "./card.vue?vue&type=template&id=cd38d510&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/home/card.css?vue&type=style&index=0&id=cd38d510&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd38d510",
  null
  
)

export default component.exports